import { render, staticRenderFns } from "./bulkofd.vue?vue&type=template&id=26549594"
import script from "./bulkofd.vue?vue&type=script&lang=js"
export * from "./bulkofd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports